import React from "react";
import { Router } from "./main/routers";
import { SettingProvider } from "./usecases/Setting";
import { GaConfigure } from "./config/ga-configure";
import ReactGA from "react-ga4";
import { BrowserRouter } from "react-router-dom";
import { ThemeConfigure } from "./config/theme-configure";
import { useCustomLocation } from "./main/hooks/useLocation";
import { BootstrapUsecase } from "./usecases/Bootstrap/usecase";
import { LocalStorage } from "./modules/LocalStorage";

ReactGA.initialize(GaConfigure.trackingId);

function App() {
  const { subDomain } = useCustomLocation();
  const [isReady, setIsReady] = React.useState<boolean>(false);

  React.useEffect(() => {
    // FIXME: cold cache double-fetches (App + Login). Make Login sole fetcher.
    async function loadTheme() {
      try {
        const tenantInfo = await new BootstrapUsecase().get({
          tenantSubDomain: subDomain,
        });
        LocalStorage.setTenantInfo(tenantInfo);
        ThemeConfigure.apply(tenantInfo.themeConfig);
      } catch (error) {
        ThemeConfigure.apply();
      } finally {
        setIsReady(true);
      }
    }
    loadTheme();
  }, [subDomain]);

  if (!isReady) {
    return null;
  }

  return (
    <SettingProvider>
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </SettingProvider>
  );
}

export default App;
